import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { LoadingService } from '../../shared/services/loading.service';
import { UserService } from '../../shared/services/user.service';
import { forkJoin } from 'rxjs';
import { User } from '../../shared/classes/user';
import { Utilities } from '../../shared/utilities';
import { Settings } from '../../shared/settings';

@Component({
  templateUrl: './backend-callback.component.html',
  styleUrls: ['./backend-callback.component.css']
})

export class BackendCallbackComponent implements OnInit, OnDestroy, AfterViewInit {
  public loading = true;
  public error = '';
  public message = '';
  public alert = '';
  private queryParamsSubscription;
  private reason = '';
  private data = {
    APPTenfieldPlayerAccessToken: ''
  };

  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const that = this;
    // that.loadingService.Open();
    // that.loading = true;

    /*that.queryParamsSubscription = that.route.queryParams.subscribe(params => {
      if (params) {
        that.reason = params.reason;
        that.checkData(params);
      }
    });*/
  }

  ngOnDestroy(): void {
    // this.queryParamsSubscription.unsubscribe();
  }

  checkData(params): void {
    const that = this;

    setTimeout(() => {
      let  dataIsValid = false;
      switch (that.reason) {
        case 'externallogin':
          if (params.accesstoken) {
            that.data.APPTenfieldPlayerAccessToken = params.accesstoken;
            dataIsValid = true;
          }
          break;
      }
      if (!dataIsValid) {
        that.error = `
            <p>
              <b>¡Ha ocurrido un error!</b>
            </p>
            <p>No se ha podido redireccionar a la pantalla correspondiente.</p>
          `;
      } else {
        that.processData();
      }
      that.loadingService.Close();
      that.loading = false;
    }, 100);
  }

  processData(): void {
    const that = this;
    if (that.reason === 'externallogin') {
      localStorage.setItem('APPTenfieldPlayerAccessToken', that.data.APPTenfieldPlayerAccessToken);
      forkJoin([
        that.userService.getUserData()
      ]).subscribe(([getUserDataResponse]) => {
        console.log(getUserDataResponse);
        if (getUserDataResponse) {
          if (!getUserDataResponse.HasError && getUserDataResponse.UsuarioData) {
            const loggedInUser = User.parse(getUserDataResponse.UsuarioData);

            that.authenticationService.loggedInUser = Object.assign({}, loggedInUser);
            localStorage.setItem('APPTenfieldPlayerLoggedInUser', JSON.stringify(loggedInUser));

            // tslint:disable-next-line:max-line-length
            // ToDo: Ver de poder redirigir al player o no, dependiendo de si hay datos de una playlist en el localsotrage.
            window.location.href = Settings.playerURL;
          }
        } else {
          that.error = `
            <p>
              <b>¡Ha ocurrido un error!</b>
            </p>
            <p>No se ha podido verificar la información del usuario logueado.</p>
          `;
        }
        },
        (error) => {
          Utilities.logError('Error al obtener la información del usuario logueado');
          Utilities.logError(error);
          that.error = `
            <p>
              <b>¡Ha ocurrido un error!</b>
            </p>
            <p>No se ha podido verificar la información del usuario logueado.</p>
          `;
          localStorage.clear();
        });
    }
  }

  public goTo(url): void {
    this.router.navigate([url]);
  }
}
